import { http } from "./http";
import moment from 'moment'
import axios, {AxiosRequestConfig} from "axios";
import {API_URL} from "./config";
import {getUserAuthTokenVerified} from "./user";
import { Http } from "./http";
// import * as Http from "http";

export interface Transfers {
    ibankref: number,
    trnDateTime: string;
    trnType: string;
    brTrnType: string,
    statusDescription: string;
    assignment: string;
    currency: string;
    amount: string;
    status: string;
    benefName: string,
    customerAccount: string,
    description: string,
    approveAvailable: boolean,
    signAvailable: boolean,
};
export interface TransfersDetail {
    userName: string,
    customerNo: number;
    phoneNumber: number;
    authType: string,
    trnAmount: number,
    trnType: string,
    trnRequestType: string,
    trnStatus: string,
    ibankref: number,
    totalSignerCount: number,
    totalApproverCount: number,
    NOTE: string,
    SIGNNUM: number,
    APPROVENUM: number,
    SIGN_DETAIL: Array<any>,
    APPROVE_DETAIL: Array<string>,
    PMTCUSTID: string,
    PMTID: string,
    CUSTCIF: number,
    CUSTNAME: string,
    COUNTERNAME: string,
    CUSTACC: string,
    BENEFNAME: string,
    BENEFACC: string,
    BENEFTAXID: number,
    BENEFBANKCODE: number,
    BENEFBANKTAXID: number,
    BENEFBANKCORACC: string,
    BENEFBANKSWIFT: string,
    BENEFBANKNAME: string,
    AMOUNT: number,
    PMTDET: string,
    INFOTOBENEF: string
};

export interface TransfersData {
    startDate: Date;
    endDate: Date;
    page: number;
    account: String,
    businessDate: string,
    status: string,
    filter: string,
    batchName:string,
    input_:string
}
export interface MassTransferFile {
    status : string,
    data : {
        fileDetailsList: [
            {
                fileBase64 : string;
                pmtid : string;
                fileName : string;
                mimeType : string;
            }
        ];
    }
    
};
export interface TransfersDetailInput {
    ibanRef: number;
};

export const getBusinessDate = async (lang:any): Promise<Transfers[]> => {
    const httpNew = new Http(lang)
    const { data } = await httpNew.get<Transfers[]>(`bank/bussinessdate`);
    return data;
};

export const getTransfersDetail = async (ibankref: any , lang?: string): Promise<TransfersDetail[]> => {
    const httpNew = new Http(lang)
    const { data } = await httpNew.get<Transfers[]>(`transaction/getransactionbyibankref/${ibankref}`);
    return data;
};

const handleFilter = (formData: any) => {
    console.log(formData)
    let s = ""
    if (formData.account && formData.account !== 'ALL') {
        s += "?account=" + `${formData.account}`;
    }
    if ((formData.status) && (formData.status !== 'ALL')) {        
        if (s != "") {         
            s += "&status=" + `${formData.status}`;
        }
        else {
            s += "?status=" + `${formData.status}`;
        }
    }
    if(formData.batchName && formData.batchName !== 'all' && formData.batchName !== 'BT'){
       
        if (s != "") {
            s += "&batchName=" + `${formData.batchName}`;
        }
        else {
            s += "?batchName=" + `${formData.batchName}`;
        }
    }else if(formData.batchName === 'all'){
        if (s != "") {
            s += "&source=" + `BT`;
        }
        else {
            s += "?source=" + `BT`;
        }
    }
    if (formData.input_) {
        if (s != "") {
            s += "&filter=" + `${formData.input_}`;
        }
        else {
            s += "?filter=" + `${formData.input_}`;
        }
    }
    return s
}

const handleFilterCount = (formData: any) => {    
    let s = ""
    if (formData.account && formData.account !== 'ALL') {
        s += "&account=" + `${formData.account}`;
    }
    if ((formData.status) && (formData.status !== 'ALL')) {        
            s += "&status=" + `${formData.status}`;
    }
    if (formData.filter) {
            s += "&filter=" + `${formData.filter}`;
    }
    return s
}

// export const getTransfers = async (formData: TransfersData, endDate: TransfersData, page: TransfersData, lang:any): Promise<Transfers[]> => {
//     const httpNew = new Http(lang)
//     let startDateData = formData.startDate ? moment(formData.startDate).format("DD.MM.YYYY") : moment(new Date()).format("DD.MM.YYYY")
//     const body = { page: 1 };
//     const { data } = await httpNew.post<any>(`/transaction/transfer-list/${startDateData}/${endDate}`, body);
//     return data;
// };
// export const getTransfersFiltered = async (businessDate: TransfersData, formData: TransfersData, page: 1, lang: any, otp?: any): Promise<Transfers[]> => {
//     const httpNew = new Http(lang)
//     let startDate = formData.startDate ? moment(formData.startDate).format("DD.MM.YYYY") : moment(new Date()).format("DD.MM.YYYY")
//     let endDate = formData.endDate ? moment(formData.endDate).format("DD.MM.YYYY") : businessDate
//     const body: any = { page: 1 };
//     if (formData.account && formData.account !== 'ALL') body.account = formData.account;
//     if (formData.status && formData.status !== 'ALL') body.status = formData.status;
//     if (formData.input_) body.filter = formData.input_;
//     if (formData.batchName === 'all') body.source = 'BT';
//     if (formData.batchName && formData.batchName !== 'all' && formData.batchName !== 'BT') body.batchName = formData.batchName;
//     if (otp) body.otp = otp;
//     const { data } = await httpNew.post<any>(`/transaction/transfer-list/${startDate}/${endDate}`, body);
//     return data;
// };

// export const getTransfersStatusCount = async (formData: TransfersData, businessDate: TransfersData): Promise<TransfersDetail[]> => {
//     let startDateData = formData.startDate ? moment(formData.startDate).format("DD.MM.YYYY") :  moment(new Date()).format("DD.MM.YYYY")
//     let endDateData = formData.endDate ? moment(formData.endDate).format("DD.MM.YYYY") : businessDate
//     const body: any = { startdate: startDateData, enddate: endDateData };
//     if (formData.account && formData.account !== 'ALL') body.account = formData.account;
//     if (formData.status && formData.status !== 'ALL') body.status = formData.status;
//     if (typeof formData.filter === 'string' && formData.filter.length > 2) body.filter = formData.filter;
//     const { data } = await http.post<any>(`transaction/transfer-count-summary`, body);
//     const sortedData = [];
//     const line1 = data?.find(e => e.status === "CLOSED")
//     if(line1 !== undefined) sortedData.push(line1)
//     const line3 = data?.find(e => e.status === "DELETED")
//     if(line3 !== undefined) sortedData.push(line3)
//     const line4 = data?.find(e => e.status === "EXPIRED")
//     if(line4 !== undefined) sortedData.push(line4)
//     const line5 = data?.find(e => e.status === "BANK_REJECTED")
//     if(line5 !== undefined) sortedData.push(line5)
//     const line6 = data?.find(e => e.status === "BANK_SUCCESS")
//     if(line6 !== undefined) sortedData.push(line6)
//     const line7 = data?.find(e => e.status === "BANK_ERROR")
//     if(line7 !== undefined) sortedData.push(line7)
//     const line8 = data?.find(e => e.status === "SEND_TO_BANK")
//     if(line8 !== undefined) sortedData.push(line8)
//     const line9 = data?.find(e => e.status === "PENDING_SIGNER")
//     if(line9 !== undefined) sortedData.push(line9)
//     const line10 = data?.find(e => e.status === "PENDING_APPROVER")
//     if(line10 !== undefined) sortedData.push(line10)
//     const line2 = data?.find(e => e.status === "PENDING_ALL")
//     if(line2 !== undefined) sortedData.push(line2)
//     const line11 = data?.find(e => e.status === "XV")
//     if(line11 !== undefined) sortedData.push(line11)
//     return sortedData;
// };

// export const getTransfersStatusCountFiltered = async (businessDate: TransfersData, formData: TransfersData): Promise<TransfersDetail[]> => {
//     let startDate = formData.startDate ? moment(formData.startDate).format("DD.MM.YYYY") :  moment(new Date()).format("DD.MM.YYYY")
//     let endDate = formData.endDate ? moment(formData.endDate).format("DD.MM.YYYY") : businessDate
//     const body: any = { startdate: startDate, enddate: endDate };
//     if (formData.account && formData.account !== 'ALL') body.account = formData.account;
//     if (formData.status && formData.status !== 'ALL') body.status = formData.status;
//     if (formData.filter) body.filter = formData.filter;
//     const { data } = await http.post<any>(`transaction/transfer-count-summary`, body);
//     return data;
// };
export const getTransfers = async (formData: TransfersData, endDate: TransfersData, _page: TransfersData, lang:any): Promise<Transfers[]> => {
    const httpNew = new Http(lang)
    let startDateData = formData.startDate ? moment(formData.startDate).format("DD.MM.YYYY") : moment(new Date()).format("DD.MM.YYYY")
    const body = { };
    const { data } = await httpNew.post<any>(`/transaction/transfer-list/${startDateData}/${endDate}`, body);
    return data;
};
export const getTransfersFiltered = async (businessDate: TransfersData, formData: TransfersData, page: 1, lang: any, otp?: any): Promise<Transfers[]> => {
    const httpNew = new Http(lang)
    let startDate = formData.startDate ? moment(formData.startDate).format("DD.MM.YYYY") : moment(new Date()).format("DD.MM.YYYY")
    let endDate = formData.endDate ? moment(formData.endDate).format("DD.MM.YYYY") : businessDate
    const body: any = {};
    if (formData.account && formData.account !== 'ALL') body.account = formData.account;
    if (formData.status && formData.status !== 'ALL') body.status = formData.status;
    if (formData.input_) body.filter = formData.input_;
    if (formData.batchName === 'all') body.source = 'BT';
    if (formData.batchName && formData.batchName !== 'all' && formData.batchName !== 'BT') body.batchName = formData.batchName;
    if (otp) body.otp = otp;
    const { data } = await httpNew.post<any>(`/transaction/transfer-list/${startDate}/${endDate}`, body);
    return data;
};

export const getTransfersStatusCount = async (formData: TransfersData, businessDate: TransfersData): Promise<TransfersDetail[]> => {
    let startDateData = formData.startDate ? moment(formData.startDate).format("DD.MM.YYYY") :  moment(new Date()).format("DD.MM.YYYY")
    let endDateData = formData.endDate ? moment(formData.endDate).format("DD.MM.YYYY") : businessDate
    const body: any = { startdate: startDateData, enddate: endDateData };
    if (formData.account && formData.account !== 'ALL') body.account = formData.account;
    if (formData.status && formData.status !== 'ALL') body.status = formData.status;
    if (typeof formData.filter === 'string' && formData.filter.length > 2) body.filter = formData.filter;
    const { data } = await http.post<any>(`transaction/transfer-count-summary`, body);
    const sortedData = [];
    const line1 = data?.find(e => e.status === "CLOSED")
    if(line1 !== undefined) sortedData.push(line1)
    const line3 = data?.find(e => e.status === "DELETED")
    if(line3 !== undefined) sortedData.push(line3)
    const line4 = data?.find(e => e.status === "EXPIRED")
    if(line4 !== undefined) sortedData.push(line4)
    const line5 = data?.find(e => e.status === "BANK_REJECTED")
    if(line5 !== undefined) sortedData.push(line5)
    const line6 = data?.find(e => e.status === "BANK_SUCCESS")
    if(line6 !== undefined) sortedData.push(line6)
    const line7 = data?.find(e => e.status === "BANK_ERROR")
    if(line7 !== undefined) sortedData.push(line7)
    const line8 = data?.find(e => e.status === "SEND_TO_BANK")
    if(line8 !== undefined) sortedData.push(line8)
    const line9 = data?.find(e => e.status === "PENDING_SIGNER")
    if(line9 !== undefined) sortedData.push(line9)
    const line10 = data?.find(e => e.status === "PENDING_APPROVER")
    if(line10 !== undefined) sortedData.push(line10)
    const line2 = data?.find(e => e.status === "PENDING_ALL")
    if(line2 !== undefined) sortedData.push(line2)
    const line11 = data?.find(e => e.status === "XV")
    if(line11 !== undefined) sortedData.push(line11)
    return sortedData;
};

export const getTransfersStatusCountFiltered = async (businessDate: TransfersData, formData: TransfersData): Promise<TransfersDetail[]> => {
    let startDate = formData.startDate ? moment(formData.startDate).format("DD.MM.YYYY") :  moment(new Date()).format("DD.MM.YYYY")
    let endDate = formData.endDate ? moment(formData.endDate).format("DD.MM.YYYY") : businessDate
    const body: any = { startdate: startDate, enddate: endDate };
    if (formData.account && formData.account !== 'ALL') body.account = formData.account;
    if (formData.status && formData.status !== 'ALL') body.status = formData.status;
    if (formData.filter) body.filter = formData.filter;
    const { data } = await http.post<any>(`transaction/transfer-count-summary`, body);
    return data;
};
export const getPaymentOrderPdfByIbanRef = async (fileDetailsList: Array<any>, lang?: any): Promise<any> => {
    const httpNew = new Http(lang)
    const { data } = await httpNew.post<any>(`file/get-list-payment-order-pdf`, fileDetailsList);
    return data;
};

export const getPaymentOrderPdfByIbanRefMultiple = async (fileDetailsList: Array<any>, lang: String): Promise<any> => {
    const httpNew = new Http(lang)
    const { data } = await httpNew.post<any>(`file/get-multiple-payment-order-pdf`, fileDetailsList);
    return data;
};

export const getRekvizitIbanRefMultiple = async (fileDetailsList: any, lang: any): Promise<any> => {
    const httpNew = new Http(lang)
    const { data } = await httpNew.post<any>(`file/get-multiple-rekvizit-pdf`, fileDetailsList);
    return data;
};

export const getAllFilesOrderAdocByIbanRef = async (ibanRef: any): Promise<MassTransferFile> => {
    const { data } = await http.get<MassTransferFile>(`file/getAllFilesByIbankref/` + ibanRef);
    return data;
};

export const getAllFilesOrderPdfByName = async (ibanRef: any, filename: any): Promise<MassTransferFile> => {
    const url = 'file/getsaveddocuments?ibankref=' + ibanRef + '&fileName=' + filename
    const { data } = await http.get<MassTransferFile>(url);
    return data;
};

export const getAllFilesOrderExcel = async (ibanRef: any,lang:any): Promise<any> => {
    const httpNew = new Http(lang)
    const url = 'file/get-salary-payment-order-excel/' + ibanRef;
    const { data } = await httpNew.get<any>(url);
    return data;
};
export const getBatchExcel = async (packagenumber: any,lang:any): Promise<any> => {
    const httpNew = new Http(lang)
    const url = `file/get-batch-excel-bypackage/${packagenumber}`;
    const { data } = await httpNew.get<any>(url);
    return data;
};

// http://{{server_host}}:{{server_port}}/eGlobeService/rest/bank/bussinessdate